import { render, staticRenderFns } from "./CremeDeLaCreme.vue?vue&type=template&id=93f3bfee&"
import script from "./CremeDeLaCreme.vue?vue&type=script&lang=js&"
export * from "./CremeDeLaCreme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports